export const successStories = [
  {
    id: 1,
    couple: '志明 & 秀英',
    marriedDate: '2024年6月',
    location: '北京',
    metDate: '2023年3月',
    duration: '15个月',
    story: '我们在富缘佳旺相识，第一次视频通话就聊了三个小时。志明是清华博士，我是北大硕士，共同的学术背景让我们有说不完的话题。平台的学历认证系统让我对他的真实性充满信心。婚礼那天，我们都感谢富缘佳旺让我们相遇。',
    husbandEdu: '博士 · 清华大学',
    wifeEdu: '硕士 · 北京大学',
    husbandJob: '大学教授',
    wifeJob: '科研工作者',
    weddingPhoto: 'https://public.readdy.ai/ai/img_res/f8bdccf96a23316ac64f63e3e6784321.jpg',
    beforePhoto1: 'https://readdy.ai/api/search-image?query=handsome%20Chinese%20man%20academic%20professor%20portrait%2C%20warm%20smile%2C%20professional%20setting%2C%20age%2033%2C%20intellectual%20appearance&width=300&height=300&seq=bef001&orientation=squarish',
    beforePhoto2: 'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20woman%20researcher%20portrait%2C%20confident%20smile%2C%20professional%20appearance%2C%20age%2029%2C%20elegant&width=300&height=300&seq=bef002&orientation=squarish',
    rating: 5,
    tags: ['视频认证', '学历匹配', '快速成功'],
  },
  {
    id: 2,
    couple: '建华 & 丽娜',
    marriedDate: '2024年10月',
    location: '上海',
    metDate: '2023年8月',
    duration: '14个月',
    story: '作为一名海归博士，我在国内找对象很困难，很多人觉得我太挑剔。在富缘佳旺，我遇到了同样有海外留学经历的丽娜。我们通过视频通话了解彼此，平台的情感教育课程也帮助我们更好地沟通。现在我们已经在上海安家，非常幸福。',
    husbandEdu: '博士 · 哈佛大学',
    wifeEdu: '硕士 · 伦敦大学',
    husbandJob: '金融总监',
    wifeJob: '国际律师',
    weddingPhoto: 'https://readdy.ai/api/search-image?query=elegant%20Chinese%20couple%20wedding%20reception%20in%20luxury%20hotel%20ballroom%2C%20modern%20wedding%20style%2C%20champagne%20toast%2C%20joyful%20celebration%2C%20professional%20photography&width=800&height=500&seq=wed002&orientation=landscape',
    beforePhoto1: 'https://readdy.ai/api/search-image?query=successful%20Chinese%20man%20finance%20director%20portrait%2C%20confident%20expression%2C%20business%20suit%2C%20age%2035%2C%20professional&width=300&height=300&seq=bef003&orientation=squarish',
    beforePhoto2: 'https://readdy.ai/api/search-image?query=elegant%20Chinese%20woman%20lawyer%20portrait%2C%20professional%20appearance%2C%20warm%20smile%2C%20age%2031%2C%20sophisticated&width=300&height=300&seq=bef004&orientation=squarish',
    rating: 5,
    tags: ['海归匹配', '情感教育', '视频认证'],
  },
  {
    id: 3,
    couple: '文博 & 晨曦',
    marriedDate: '2025年1月',
    location: '成都',
    metDate: '2023年11月',
    duration: '14个月',
    story: '我是一名医生，工作很忙，没有时间去相亲。富缘佳旺的智能匹配系统根据我的学历和职业为我推荐了文博，他是一位工程师，同样忙碌但同样认真。我们通过视频通话慢慢了解，平台的婚前辅导课程让我们对婚姻有了更深的认识。',
    husbandEdu: '硕士 · 电子科技大学',
    wifeEdu: '本科 · 四川大学医学院',
    husbandJob: '高级工程师',
    wifeJob: '外科医生',
    weddingPhoto: 'https://readdy.ai/api/search-image?query=happy%20Chinese%20couple%20outdoor%20garden%20wedding%20ceremony%2C%20natural%20setting%20with%20flowers%2C%20warm%20sunlight%2C%20romantic%20and%20intimate%20atmosphere%2C%20professional%20photography&width=800&height=500&seq=wed003&orientation=landscape',
    beforePhoto1: 'https://readdy.ai/api/search-image?query=Chinese%20engineer%20man%20portrait%2C%20friendly%20smile%2C%20casual%20professional%20style%2C%20age%2031%2C%20approachable&width=300&height=300&seq=bef005&orientation=squarish',
    beforePhoto2: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20doctor%20surgeon%20portrait%2C%20kind%20expression%2C%20medical%20professional%2C%20age%2028%2C%20trustworthy&width=300&height=300&seq=bef006&orientation=squarish',
    rating: 5,
    tags: ['智能匹配', '婚前辅导', '医生专属'],
  },
  {
    id: 4,
    couple: '俊杰 & 雨桐',
    marriedDate: '2024年8月',
    location: '深圳',
    metDate: '2023年5月',
    duration: '15个月',
    story: '我是一名创业者，雨桐是一名设计师。我们在平台上相遇，共同的创业精神让我们一拍即合。富缘佳旺的视频认证功能让我们第一次见面就充满信任，不需要担心对方的真实性。现在我们不仅是夫妻，也是创业伙伴。',
    husbandEdu: '硕士 · 浙江大学',
    wifeEdu: '本科 · 中国美术学院',
    husbandJob: '科技创业者',
    wifeJob: 'UI/UX设计师',
    weddingPhoto: 'https://readdy.ai/api/search-image?query=modern%20stylish%20Chinese%20couple%20wedding%20in%20contemporary%20art%20gallery%20setting%2C%20creative%20decoration%2C%20urban%20chic%20style%2C%20joyful%20expressions%2C%20professional%20photography&width=800&height=500&seq=wed004&orientation=landscape',
    beforePhoto1: 'https://readdy.ai/api/search-image?query=young%20Chinese%20startup%20founder%20man%20portrait%2C%20energetic%20expression%2C%20casual%20smart%20style%2C%20age%2030%2C%20innovative%20look&width=300&height=300&seq=bef007&orientation=squarish',
    beforePhoto2: 'https://readdy.ai/api/search-image?query=creative%20Chinese%20woman%20designer%20portrait%2C%20artistic%20style%2C%20bright%20smile%2C%20age%2027%2C%20creative%20appearance&width=300&height=300&seq=bef008&orientation=squarish',
    rating: 5,
    tags: ['创业者匹配', '视频认证', '快速成功'],
  },
  {
    id: 5,
    couple: '国强 & 婉儿',
    marriedDate: '2024年4月',
    location: '广州',
    metDate: '2023年1月',
    duration: '15个月',
    story: '我在富缘佳旺找到了我的灵魂伴侣。婉儿是一位大学老师，我是一名律师，我们都重视教育和家庭。平台的情感教育课程帮助我们在婚前就建立了良好的沟通基础。我们的婚礼非常温馨，感谢富缘佳旺！',
    husbandEdu: '博士 · 中山大学',
    wifeEdu: '博士 · 华南理工大学',
    husbandJob: '律师',
    wifeJob: '大学教授',
    weddingPhoto: 'https://readdy.ai/api/search-image?query=traditional%20Chinese%20wedding%20banquet%20celebration%2C%20red%20lanterns%20and%20decorations%2C%20happy%20family%20gathering%2C%20warm%20festive%20atmosphere%2C%20professional%20photography&width=800&height=500&seq=wed005&orientation=landscape',
    beforePhoto1: 'https://readdy.ai/api/search-image?query=Chinese%20lawyer%20man%20portrait%2C%20professional%20serious%20expression%2C%20formal%20attire%2C%20age%2036%2C%20authoritative&width=300&height=300&seq=bef009&orientation=squarish',
    beforePhoto2: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20professor%20portrait%2C%20intellectual%20appearance%2C%20warm%20smile%2C%20age%2033%2C%20academic%20style&width=300&height=300&seq=bef010&orientation=squarish',
    rating: 5,
    tags: ['博士匹配', '情感教育', '学历优先'],
  },
  {
    id: 6,
    couple: '明轩 & 诗涵',
    marriedDate: '2025年2月',
    location: '杭州',
    metDate: '2024年1月',
    duration: '13个月',
    story: '我们都是互联网行业的从业者，在富缘佳旺相遇。诗涵的聪明和独立深深吸引了我，而她说我的真诚和上进心让她放心。平台的视频认证让我们省去了很多顾虑，直接进入深度了解阶段。现在我们在杭州共同生活，非常幸福。',
    husbandEdu: '硕士 · 浙江大学',
    wifeEdu: '硕士 · 复旦大学',
    husbandJob: '产品经理',
    wifeJob: '数据科学家',
    weddingPhoto: 'https://readdy.ai/api/search-image?query=young%20Chinese%20couple%20intimate%20wedding%20ceremony%20lakeside%2C%20beautiful%20natural%20scenery%2C%20romantic%20sunset%20lighting%2C%20modern%20wedding%20style%2C%20professional%20photography&width=800&height=500&seq=wed006&orientation=landscape',
    beforePhoto1: 'https://readdy.ai/api/search-image?query=Chinese%20product%20manager%20man%20portrait%2C%20friendly%20approachable%20expression%2C%20casual%20professional%2C%20age%2029%2C%20modern&width=300&height=300&seq=bef011&orientation=squarish',
    beforePhoto2: 'https://readdy.ai/api/search-image?query=Chinese%20data%20scientist%20woman%20portrait%2C%20intelligent%20expression%2C%20professional%20appearance%2C%20age%2027%2C%20tech%20industry&width=300&height=300&seq=bef012&orientation=squarish',
    rating: 5,
    tags: ['互联网行业', '视频认证', '快速成功'],
  },
];
